// deeplink wire format(`similar_goods`)은 구버전 네이티브 딥링크 라우터 호환을 위해 유지하고,
// 신규 엔드포인트 type 은 OTA 갱신되는 이 레이어에서 변환한다.
const LEGACY_TYPE_MAP: { [key: string]: string } = {
  similar_goods: 'view-together',
};

export const resolveGoodsListType = (type: string) =>
  LEGACY_TYPE_MAP[type] ?? type;
